import { CKEditor } from 'ckeditor4-react';
import React, { useEffect } from 'react';
import appConfig from '../../app-config';
import PropTypes from 'prop-types';

const Index = ({
  editorData,
  setEditorData
}) =>{
  const baseUrl = appConfig.apiBaseUrl;

  useEffect(() => {
    const mathjaxLink = document.createElement('link');
    mathjaxLink.rel = 'stylesheet';
    mathjaxLink.href = `${baseUrl}/ckeditor/dist/ckeditor_eq_editor/styles/mathjax_editor.bundle.css`;
    document.head.appendChild(mathjaxLink);

    const wirisThemeLink = document.createElement('link');
    wirisThemeLink.rel = 'stylesheet';
    wirisThemeLink.href = `${baseUrl}/ckeditor/dist/ckeditor_eq_editor/styles/wiris_theme.bundle.css`;
    document.head.appendChild(wirisThemeLink);

    return () => {
      document.head.removeChild(mathjaxLink);
      document.head.removeChild(wirisThemeLink);
    };
  }, []);

  const handleEditorChange = (event) => {
    setEditorData(event.editor.getData());
  };
  
  return (
    <>
      <div>
        <CKEditor
          editorUrl={`${baseUrl}/ckeditor/ckeditor.js`}
          config={{
            toolbar:'InternalWiris',
            extraPlugins: 'ckeditor_eq_editor,ckeditor_chemeq_editor',
            height: 300
          }}
          initData={editorData} 
          onChange={handleEditorChange}     
        />
      </div>
    </>
  );
};

Index.propTypes = {
  editorData: PropTypes.string,
  setEditorData: PropTypes.func
};

export default Index;
